/* eslint-disable no-magic-numbers */
/* global window */

import _ from 'lodash';
import * as types from '../../../../store/mutation-types';
import { COUPON_CHECK_WAIT } from '../../../../store/constants';
import HumanJoin from '../../../../mixins/human_join';
import PhotoSelector from '../../../photo-selector/photo-selector.vue';
import { getCheckoutUrl, getInitialPaymentMethod, isPaymentModeActive } from '../../../../helpers/map-helpers';

export default {
  mixins: [HumanJoin],
  components: { PhotoSelector },
  props: ['plotCartSize', 'activeProject'],
  data() {
    return {
      paymentMode: null,
      uploadStatus: false,
      form: {},
      uploadError: [],
      submittingPurchaseInfo: false,
      couponCode: null,
      coupon: {},
      loadingCoupon: false,
      applyingCoupon: false,
    };
  },
  computed: {
    apiToken() {
      return this.$store.state.auth.apiToken;
    },
    bounds() {
      return this.$store.state.map.bounds;
    },
    purchase() {
      return this.$store.state.map.purchase;
    },
    currentZoom() {
      return this.$store.state.map.currentZoom;
    },
    paymentMethods() {
      return this.$store.getters.paymentMethods;
    },
    price() {
      return Number(this.activeProject.picValue[0]);
    },
    currency() {
      return this.activeProject.picValue[1];
    },
  },
  mounted() {
    this.paymentMode = getInitialPaymentMethod(this.paymentMethods) || 'paypal';
  },
  methods: {
    submitPic() {
      this.$validator
        .validateAll()
        .then(() => this.$store.dispatch('updatePicInformation', {
          name: this.form.name,
          email: this.form.email,
          uploadIdentifier: this.form.uploadIdentifier,
          pictureId: this.form.pictureId,
        }))
        .then(() => {
          if (!this.bounds) return false;
          const center = this.bounds.getCenter();
          const currentZoom = this.currentZoom;
          if (this.paymentMode === 'coupon') {
            this.$store.commit(types.SET_MAP_CENTER, center);

            return this.$store.dispatch('checkoutPurchase');
          } else if (this.paymentMode === 'paypal' || this.paymentMode === 'mercadopago') {
            window.location.href = getCheckoutUrl({
              token: this.apiToken,
              paymentMode: this.paymentMode,
              zoom: currentZoom,
            });

            return true;
          }

          return false;
        })
        .then(() => {
          if (this.paymentMode === 'coupon') {
            this.applyingCoupon = false;
            this.$store.commit(types.CLEAR_CART);
          }
        })
        .catch(err => {
          this.$store.dispatch('cancelPurchase');
          console.log(err);
        });
    },
    uploadDone() {
      this.uploadStatus = 'uploaded';
    },
    availableForActiveProject(coupon) {
      return (_.isEmpty(coupon.projects) || coupon.projects.find(x => x.id === this.activeProject.id) !== undefined);
    },
    checkAndEnableUpload(selectedFile) {
      if (selectedFile.errors.length) {
        this.uploadError = selectedFile.errors;
      } else {
        this.uploadStatus = 'ready';
        this.uploadError = [];
      }
    },
    checkCouponCode: _.debounce(
      function () {
        this.loadingCoupon = true;
        this.$store.dispatch('checkCoupon', { couponCode: this.couponCode.toUpperCase(),
          activeProjectSlug: this.activeProject.slug })
          .then(coupon => {
            this.loadingCoupon = false;
            if (coupon) {
              this.coupon = coupon;
              if (this.coupon.campaignAmount >= this.plotCartSize && this.coupon.available) {
                this.$store.commit(types.SAVE_COUPON, this.couponCode);
              }
            } else {
              this.$store.commit(types.RESET_COUPON);
              this.coupon = {};
            }
          });
      },
      COUPON_CHECK_WAIT,
      {
        leading: true,
      }
    ),
  },
  watch: {
    activeProject() {
      if (!isPaymentModeActive(this.paymentMethods, this.paymentMode)) {
        this.paymentMode = getInitialPaymentMethod(this.paymentMethods);
      }
    },
  },
};
